import {createApi, createEvent, createStore} from "effector";

export const setUserId = createEvent<number>()

export const $userId = createStore<number>(0)
    .on(setUserId, (_, payloadUserId) => payloadUserId)